import produce from 'immer'
import { isValidHttpUrl } from './utils'

import {
  FETCH_QUEUES,
  FETCH_QUEUES_SUCCESS,
  FETCH_QUEUES_FAILURE,
  FETCH_QUEUE_COUNTS,
  FETCH_QUEUE_COUNTS_FAILURE,
  FETCH_QUEUE_COUNTS_SUCCESS,
  TRIGGER_SERVICE,
  TRIGGER_SERVICE_FAILURE,
  TRIGGER_SERVICE_SUCCESS,
  RETRY_DLQ_MESSAGES,
  RETRY_DLQ_MESSAGES_FAILURE,
  RETRY_DLQ_MESSAGES_SUCCESS,
  CLEAR_DLQ,
  CLEAR_DLQ_FAILURE,
  CLEAR_DLQ_SUCCESS,
} from '../actions/types'

export const initialQueueState = {
  id: null,
  title: null,
  uri: null,
  deadLetterQueueUri: null,
  triggerable: false,

  error: null,
  fetched: false,
  fetching: false,
  lastFetched: null,

  approximateNumberOfMessages: 0,
  approximateNumberOfMessagesNotVisible: 0,
  approximateNumberOfMessagesInDlq: 0,
  approximateNumberOfMessagesNotVisibleInDlq: 0,

  triggerServicePending: false,
  triggerServiceSuccess: false,
  triggerServiceError: null,

  retryDLQMessagesPending: false,
  retryDLQMessagesSuccess: false,
  retryDLQMessagesError: null,

  clearDLQPending: false,
  clearDLQSuccess: false,
  clearDLQError: null,
}

export const initialState = {
  allIds: [],
  byId: {},
  error: null,
  fetched: false,
  fetching: false,
  lastFetched: null,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_QUEUES: {
      draft.fetching = true
      break
    }
    case FETCH_QUEUES_SUCCESS: {
      const queues = payload

      // Update async state flags
      draft.error = null
      draft.fetching = false
      draft.fetched = true
      draft.lastFetched = new Date()

      // Add all queues to state
      for (const queue of queues) {
        const { id, uri, deadLetterQueueUri } = queue
        // only add queues with set/ valid queue urls for the environment
        if (isValidHttpUrl(uri) && isValidHttpUrl(deadLetterQueueUri) && draft.allIds.indexOf(id) < 0) {
          draft.allIds.push(id)
        }

        draft.byId[id] = {
          ...initialQueueState,
          ...queue,
        }
      }

      break
    }
    case FETCH_QUEUES_FAILURE: {
      const error = payload
      draft.fetching = false
      draft.fetched = true
      draft.error = error
      break
    }
    case FETCH_QUEUE_COUNTS: {
      const { queueId } = payload
      draft.byId[queueId].fetching = true
      break
    }
    case FETCH_QUEUE_COUNTS_SUCCESS: {
      const { queueId, counts } = payload
      draft.byId[queueId].error = null
      draft.byId[queueId].fetching = false
      draft.byId[queueId].fetched = true
      draft.byId[queueId].lastFetched = new Date()
      draft.byId[queueId] = {
        ...draft.byId[queueId],
        ...counts,
      }

      break
    }
    case FETCH_QUEUE_COUNTS_FAILURE: {
      const { queueId, error } = payload
      draft.byId[queueId].fetching = false
      draft.byId[queueId].fetched = true
      draft.byId[queueId].error = error
      break
    }
    case TRIGGER_SERVICE: {
      const { queueId } = payload
      draft.byId[queueId].triggerServicePending = true
      break
    }
    case TRIGGER_SERVICE_SUCCESS: {
      const { queueId } = payload
      draft.byId[queueId].triggerServicePending = false
      draft.byId[queueId].triggerServiceSuccess = true
      draft.byId[queueId].triggerServiceError = null
      break
    }
    case TRIGGER_SERVICE_FAILURE: {
      const { queueId, error } = payload
      draft.byId[queueId].triggerServicePending = false
      draft.byId[queueId].triggerServiceSuccess = false
      draft.byId[queueId].triggerServiceError = error
      break
    }
    case RETRY_DLQ_MESSAGES: {
      const { queueId } = payload
      draft.byId[queueId].retryDLQMessagesPending = true
      break
    }
    case RETRY_DLQ_MESSAGES_SUCCESS: {
      const { queueId } = payload
      draft.byId[queueId].retryDLQMessagesPending = false
      draft.byId[queueId].retryDLQMessagesSuccess = true
      draft.byId[queueId].retryDLQMessagesError = null
      break
    }
    case RETRY_DLQ_MESSAGES_FAILURE: {
      const { queueId, error } = payload
      draft.byId[queueId].retryDLQMessagesPending = false
      draft.byId[queueId].retryDLQMessagesSuccess = false
      draft.byId[queueId].retryDLQMessagesError = error
      break
    }
    case CLEAR_DLQ: {
      const { queueId } = payload
      draft.byId[queueId].clearDLQPending = true
      break
    }
    case CLEAR_DLQ_SUCCESS: {
      const { queueId } = payload
      draft.byId[queueId].clearDLQPending = false
      draft.byId[queueId].clearDLQSuccess = true
      draft.byId[queueId].clearDLQError = null
      break
    }
    case CLEAR_DLQ_FAILURE: {
      const { queueId, error } = payload
      draft.byId[queueId].clearDLQPending = false
      draft.byId[queueId].clearDLQSuccess = false
      draft.byId[queueId].clearDLQError = error
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
